import { render, staticRenderFns } from "./Accordion-Services.vue?vue&type=template&id=7e6d906c"
import script from "./Accordion-Services.vue?vue&type=script&lang=js"
export * from "./Accordion-Services.vue?vue&type=script&lang=js"
import style0 from "./Accordion-Services.vue?vue&type=style&index=0&id=7e6d906c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports